export default "__VITE_ASSET__Cl2xa6Ve__"